<template>
    <div class="content-wrapper">
        <app-page-top-section title="Ontech Pad Settings" icon="settings" />

        <div class="row">
            <div class="col-md-12">
                <div class="card card-with-shadow border-0 mb-primary">
                    <div class="card-body">
                        <form @submit.prevent="submitForm" enctype="multipart/form-data">
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label">Logo</label>
                                <div class="col-sm-10">
                                    <app-input
                                        id="padLogo"
                                        v-if="imageUploaderBoot"
                                        type="custom-file-upload"
                                        :generate-file-url="false"
                                        v-model="files.logo"
                                        label="Change Logo"
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label">Background Image</label>
                                <div class="col-sm-10">
                                    <app-input
                                        id="padBackgroundImage"
                                        v-if="imageUploaderBoot"
                                        type="custom-file-upload"
                                        :generate-file-url="false"
                                        v-model="files.background_image"
                                        label="Change Background Image"
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label">Footer Logo</label>
                                <div class="col-sm-10">
                                    <app-input
                                        id="padFooterLogo"
                                        v-if="imageUploaderBoot"
                                        type="custom-file-upload"
                                        :generate-file-url="false"
                                        v-model="files.footer_logo"
                                        label="Change Footer Logo"
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label">Signature Image</label>
                                <div class="col-sm-10">
                                    <app-input
                                        id="padSignatureImage"
                                        v-if="imageUploaderBoot"
                                        type="custom-file-upload"
                                        :generate-file-url="false"
                                        v-model="files.signature_image"
                                        label="Change Signature Image"
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label">Address</label>
                                <div class="col-sm-10">
                                    <textarea class="form-control" v-model="form.address"></textarea>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label">Phone 1</label>
                                <div class="col-sm-10">
                                    <input type="text" class="form-control" v-model="form.phone_1">
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label">Phone 2</label>
                                <div class="col-sm-10">
                                    <input type="text" class="form-control" v-model="form.phone_2">
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label">Website</label>
                                <div class="col-sm-10">
                                    <input type="text" class="form-control" v-model="form.website">
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label">Email</label>
                                <div class="col-sm-10">
                                    <input type="text" class="form-control" v-model="form.email">
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label">Signature Text</label>
                                <div class="col-sm-10">
                                    <textarea class="form-control" v-model="form.signature_text" rows="4" placeholder="Enter Signature Text (e.g. Rezaul Alam&#10;CEO & CTO&#10;OntechIct Ltd&#10;+8801687855988)"></textarea>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-sm-10 offset-sm-2">
                                    <button type="submit" class="btn btn-primary" :disabled="loading">
                                        <span v-if="loading">Saving...</span>
                                        <span v-else>Save</span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <!-- Preview Area -->
                <div class="card card-with-shadow border-0 mb-primary mt-4">
                    <div class="card-header bg-transparent border-0">
                        <h4 class="card-title">Live Preview</h4>
                    </div>
                    <div class="card-body">
                        <div class="pad-preview-container">
                            <div class="page" :style="backgroundStyle">
                                <div class="watermark" :style="watermarkStyle"></div>

                                <!-- HEADER -->
                                <div class="header">
                                    <div class="logo-area">
                                        <img v-if="previewLogo" :src="previewLogo" alt="Logo">
                                    </div>

                                    <div class="contact-info">
                                        <div class="contact-row" v-if="form.address">
                                            <svg viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z"/></svg>
                                            <span class="addr-text" v-html="form.address.replace(/\n/g, '<br>')"></span>
                                        </div>
                                        <div class="contact-row" v-if="form.phone_1">
                                            <svg viewBox="0 0 24 24"><path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 011 1V20a1 1 0 01-1 1C9.39 21 3 14.61 3 7a1 1 0 011-1h3.5a1 1 0 011 1c0 1.26.2 2.47.57 3.58a1 1 0 01-.25 1.01l-2.2 2.2z"/></svg>
                                            <span>{{ form.phone_1 }}</span>
                                        </div>
                                        <div class="contact-row" v-if="form.phone_2">
                                            <svg viewBox="0 0 24 24"><path d="M20 2H4a2 2 0 00-2 2v18l4-4h14a2 2 0 002-2V4a2 2 0 00-2-2z"/></svg>
                                            <span>{{ form.phone_2 }}</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- BODY -->
                                <div class="body-content">
                                    <!-- Signature Block -->
                                    <div class="signature-block" v-if="previewSignatureImage || form.signature_text">
                                        <div class="sig-line" v-if="previewSignatureImage">
                                            <img :src="previewSignatureImage" alt="Signature">
                                        </div>
                                        <div class="sig-divider"></div>
                                        <div class="sig-text" v-if="form.signature_text" v-html="form.signature_text.replace(/\n/g, '<br>')"></div>
                                    </div>
                                </div>

                                <!-- FOOTER -->
                                <div class="footer">
                                    <div class="footer-bar">
                                        <div class="footer-left">
                                            <div class="footer-logo-blob">
                                                <img v-if="previewFooterLogo" :src="previewFooterLogo" alt="Footer Logo">
                                            </div>
                                            <div class="footer-text">
                                                <span v-if="form.website">{{ form.website }}</span>
                                                <span v-if="form.email">E-mail : {{ form.email }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {urlGenerator} from "../../../../common/Helper/AxiosHelper";
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";

export default {
    name: "OntechPadSettings",
    mixins: [FormHelperMixins],
    data() {
        return {
            loading: false,
            imageUploaderBoot: false,
            form: {
                address: '',
                phone_1: '',
                phone_2: '',
                website: '',
                email: '',
                signature_text: ''
            },
            files: {
                logo: null,
                background_image: null,
                footer_logo: null,
                signature_image: null
            },
            serverData: {
                logo: null,
                background_image: null,
                footer_logo: null,
                signature_image: null
            },
            previewImages: {
                logo: null,
                background_image: null,
                footer_logo: null,
                signature_image: null
            }
        };
    },
    computed: {
        previewLogo() {
            if (!this.files.logo) return this.serverData.logo;
            if (typeof this.files.logo === 'string') return this.files.logo;
            if (this.files.logo.url) return this.files.logo.url;
            if (this.files.logo instanceof Blob || this.files.logo instanceof File) return URL.createObjectURL(this.files.logo);
            return this.serverData.logo;
        },
        previewFooterLogo() {
            if (!this.files.footer_logo) return this.serverData.footer_logo;
            if (typeof this.files.footer_logo === 'string') return this.files.footer_logo;
            if (this.files.footer_logo.url) return this.files.footer_logo.url;
            if (this.files.footer_logo instanceof Blob || this.files.footer_logo instanceof File) return URL.createObjectURL(this.files.footer_logo);
            return this.serverData.footer_logo;
        },
        previewBackgroundImage() {
            if (!this.files.background_image) return this.serverData.background_image;
            if (typeof this.files.background_image === 'string') return this.files.background_image;
            if (this.files.background_image.url) return this.files.background_image.url;
            if (this.files.background_image instanceof Blob || this.files.background_image instanceof File) return URL.createObjectURL(this.files.background_image);
            return this.serverData.background_image;
        },
        previewSignatureImage() {
            if (!this.files.signature_image) return this.serverData.signature_image;
            if (typeof this.files.signature_image === 'string') return this.files.signature_image;
            if (this.files.signature_image.url) return this.files.signature_image.url;
            if (this.files.signature_image instanceof Blob || this.files.signature_image instanceof File) return URL.createObjectURL(this.files.signature_image);
            return this.serverData.signature_image;
        },
        backgroundStyle() {
            return {};
        },
        watermarkStyle() {
            if (this.previewBackgroundImage) {
                return {
                    backgroundImage: `url(${this.previewBackgroundImage})`
                };
            }
            return {};
        }
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            axios.get(urlGenerator('app/settings/ontech-pad'))
                .then(response => {
                    if (response.data) {
                        this.form.address = response.data.address || '';
                        this.form.phone_1 = response.data.phone_1 || '';
                        this.form.phone_2 = response.data.phone_2 || '';
                        this.form.website = response.data.website || '';
                        this.form.email = response.data.email || '';
                        this.form.signature_text = response.data.signature_text || '';
                        
                        this.serverData.logo = response.data.logo ? urlGenerator(response.data.logo) : null;
                        this.serverData.background_image = response.data.background_image ? urlGenerator(response.data.background_image) : null;
                        this.serverData.footer_logo = response.data.footer_logo ? urlGenerator(response.data.footer_logo) : null;
                        this.serverData.signature_image = response.data.signature_image ? urlGenerator(response.data.signature_image) : null;
                        
                        this.files.logo = this.serverData.logo;
                        this.files.background_image = this.serverData.background_image;
                        this.files.footer_logo = this.serverData.footer_logo;
                        this.files.signature_image = this.serverData.signature_image;
                        
                        this.imageUploaderBoot = true;
                    }
                })
                .catch(error => {
                    console.error("Error fetching pad data:", error);
                });
        },
        submitForm() {
            this.loading = true;
            let formData = new FormData();
            
            formData.append('address', this.form.address);
            formData.append('phone_1', this.form.phone_1);
            formData.append('phone_2', this.form.phone_2);
            formData.append('website', this.form.website);
            formData.append('email', this.form.email);
            formData.append('signature_text', this.form.signature_text || '');
            
            if (this.files.logo && this.files.logo instanceof File) formData.append('logo', this.files.logo);
            if (this.files.background_image && this.files.background_image instanceof File) formData.append('background_image', this.files.background_image);
            if (this.files.footer_logo && this.files.footer_logo instanceof File) formData.append('footer_logo', this.files.footer_logo);
            if (this.files.signature_image && this.files.signature_image instanceof File) formData.append('signature_image', this.files.signature_image);

            axios.post(urlGenerator('app/settings/ontech-pad'), formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                this.$toastr.s(response.data.message);
                this.loading = false;
                this.fetchData(); // refresh server data URLs
            })
            .catch(error => {
                this.$toastr.e("Error saving settings");
                this.loading = false;
            });
        }
    }
}
</script>

<style scoped>
/* Scoped styles mimicking ontech_letterhead (2).html */
.pad-preview-container {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background: #e0e0e0;
    padding: 20px;
}

.page {
    width: 794px;
    min-height: 1123px;
    background: #ffffff;
    position: relative;
    overflow: hidden;
    box-shadow: 0 4px 24px rgba(0,0,0,0.18);
    transform: scale(0.6);
    transform-origin: top center;
    margin-bottom: -450px; /* offset the scale space */
}

/* ── WATERMARK ── */
.watermark {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 400px;
    height: 400px;
    opacity: 0.06;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 0;
}

/* ── HEADER ── */
.header {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 32px 12px 28px;
    border-bottom: 3px solid #f0b800;
}

.logo-area img {
    height: 68px;
    display: block;
    object-fit: contain;
}

.contact-info {
    text-align: left;
    font-size: 11.5px;
    color: #111;
    line-height: 1.0;
}

.contact-row {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    margin-bottom: 6px;
}
.contact-row:last-child { margin-bottom: 0; }

.contact-info svg {
    width: 14px;
    height: 14px;
    fill: #111;
    flex-shrink: 0;
    margin-top: 1px;
}

.addr-text { line-height: 1.55; }

/* ── BODY ── */
.body-content {
    position: relative;
    z-index: 1;
    padding: 36px 32px;
    min-height: 960px;
}

/* ── SIGNATURE BLOCK ── */
.signature-block {
    position: absolute;
    bottom: 110px;
    left: 32px;
    text-align: left;
    width: 240px;
}
.sig-line img {
    max-height: 55px;
    max-width: 180px;
    object-fit: contain;
    display: block;
    margin-bottom: 4px;
}
.sig-divider {
    border-top: 1px dotted #888;
    margin: 4px 0 6px 0;
    width: 100%;
}
.sig-text {
    font-size: 11.5px;
    color: #111;
    line-height: 1.45;
}

/* ── FOOTER ── */
.footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
}

.footer-bar {
    background: #f5e3c0;
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    min-height: 74px;
}

.footer-left {
    display: flex;
    align-items: center;
    flex: 1;
}

.footer-logo-blob {
    background: #c8a0d8;
    width: 90px;
    min-height: 74px;
    border-radius: 0 50px 50px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    overflow: hidden;
}

.footer-logo-blob img {
    width: 54px;
    height: 54px;
    object-fit: contain;
    border-radius: 50%;
}

.footer-text {
    font-size: 11px;
    color: #111;
    line-height: 1.9;
    padding-left: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
</style>
